export const validateMaterial = (value: string) => {
  if (!value) {
    return "Material is required";
  }

  if (value !== value.trim()) {
    return "Material cannot contain spaces at the beginning or end";
  }

  if (/\s{3,}/.test(value)) {
    return "Material cannot contain more than two consecutive spaces";
  }

  const allowedSpecialChars = /^[a-zA-Z0-9\s_/\-+.]+$/;
  if (!allowedSpecialChars.test(value)) {
    return "Material can only contain letters, numbers, spaces and the characters _ / - + .";
  }

  if (!/^[a-zA-Z0-9].*[a-zA-Z0-9]$|^[a-zA-Z0-9]$/.test(value)) {
    return "Material must start and end with a letter or number";
  }

  return undefined;
};
